import { SystemBase } from "@inter-ikea-core/core-toolbox";
import { ComponentIds, HierarchyUtils, } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "../storage2ComponentIDs";
import { updateBlockedHoles } from "../functions/blockConnectionHole";
export class BlockConnectionHoleSystem extends SystemBase {
    constructor(entityManager) {
        super(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID);
        this.entityManager = entityManager;
        this.doingChangesOnComponent = [];
        this.id = "BlockConnectionHoleSystem";
        /**
         * Checks if the entity has any connection related to the wall
         * @param entity
         * @returns
         */
        this.entityAttachedToWall = (entity) => {
            const parent = HierarchyUtils.parent(entity);
            if (!parent)
                return false;
            return (parent === null || parent === void 0 ? void 0 : parent.hasComponent(ComponentIds.ROOM_COMPONENT_ID)) ? true : false;
        };
        this.systemsAfterMe = null;
        this.systemsBeforeMe = null;
    }
    onAddComponent(_entity, _newComponent) {
        super.onAddComponent(_entity, _newComponent);
        if (_entity.hasComponent(COMPONENT_IDS.BLOCK_CONNECTION_HOLE_COMPONENT) &&
            !this.entityAttachedToWall(_entity)) {
            updateBlockedHoles(_entity);
        }
    }
    onUpdateComponent(_entity, _oldComponent, _newComponent) {
        super.onUpdateComponent(_entity, _oldComponent, _newComponent);
        if (_entity.hasComponent(COMPONENT_IDS.BLOCK_CONNECTION_HOLE_COMPONENT) &&
            !this.entityAttachedToWall(_entity)) {
            updateBlockedHoles(_entity);
        }
    }
    onRemoveComponent(_entity, _oldComponent) {
        super.onRemoveComponent(_entity, _oldComponent);
    }
}
